module.exports = __webpack_public_path__ + "img/party_popper.3b1a081b.png";